import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {formatarDataISO8601, formatarValorReal, formatTelefone} from "../../../../utils/formatar";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import {Validacao} from "../../../comum/components/Validacao";

@inject("store")
@observer
export class DetalhamentoPagamento extends Component {
    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    render() {
        const dados = this.controller.detalhesPagamento;
        return (
            <div>
                <h4>Pagamento</h4>
                <Row>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Lote</Label>
                            <Input type="text" value={dados.id} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Unidade de negócio (BU)</Label>
                            <Input type="text" value={dados.nomeEmpresaGlobo} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Valor total</Label>
                            <Input type="text" value={formatarValorReal(dados.valorTotal)} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Data geração</Label>
                            <Input type="text" value={formatarDataISO8601(dados.dataGeracao)} readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}